// client/src/pages/Settings.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

function Settings() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="card" style={{ textAlign: 'center', padding: 40 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⚙️</div>
        <h2 style={{ marginBottom: 8 }}>设置</h2>
        <p style={{ color: '#666', marginBottom: 24 }}>功能开发中，敬请期待</p>
        <button 
          className="btn btn-primary"
          onClick={() => navigate('/profile')}
        >
          返回我的
        </button>
      </div>
    </Layout>
  );
}

export default Settings;
